import React from 'react';
import logo from '../img/Logo.png';

const Footer = () => {
  return (
    <footer className="relative w-full bg-gradient-to-b from-slate-950 to-slate-900 overflow-hidden">
      {/* Enhanced Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Sophisticated gradient overlays */}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-cyan-400/8 via-blue-500/6 to-indigo-600/8 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-gradient-to-br from-purple-400/6 via-violet-500/8 to-pink-500/6 rounded-full blur-3xl animate-float-delayed" />
        <div className="absolute top-1/2 left-1/2 w-72 h-72 bg-gradient-to-br from-emerald-400/4 to-teal-500/6 rounded-full blur-3xl animate-float-slow transform -translate-x-1/2 -translate-y-1/2" />
        
        {/* Refined grid pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(148,163,184,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(148,163,184,0.03)_1px,transparent_1px)] bg-[size:60px_60px] opacity-30" />
        
        {/* Subtle noise texture */}
      </div>

      <div className="relative z-10 w-full max-w-[100vw] mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-24">
        
        {/* Main Footer Content */}
        <div className="group relative animate-fade-in mb-12 sm:mb-16">
          {/* Glow effect on hover */}
          <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500/10 via-purple-500/10 to-blue-500/10 rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-all duration-1000" />
          
          <div className="relative bg-slate-900/40 backdrop-blur-2xl border border-slate-700/40 rounded-3xl p-6 sm:p-8 lg:p-14 hover:border-slate-600/60 hover:bg-slate-900/50 transition-all duration-700 shadow-2xl shadow-slate-950/50">
            
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
              
              {/* Company Info Section - Takes more space */}
              <div className="lg:col-span-5 animate-slide-up">
                {/* Company Logo/Name with enhanced styling */}
                <div className="mb-6 sm:mb-8">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center overflow-hidden">
                      <img 
                        src={logo} 
                        alt="JTG Enterprises Logo" 
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-white via-slate-100 to-slate-300 bg-clip-text text-transparent mb-1">
                        JTG Enterprises Limited
                      </h2>
                    </div>
                  </div>
                  <p className="text-lg sm:text-xl text-cyan-300/90 font-medium tracking-wide font-script">Engineering Your Dreams With Us</p>
                  <div className="w-24 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full mt-4"></div>
                </div>

                {/* Enhanced description */}
                <p className="text-slate-300 leading-relaxed mb-6 sm:mb-8 text-base sm:text-lg">
                  Delivering innovative solutions and exceptional service to drive sustainable growth and positive impact across communities.
                </p>

                {/* Contact Info with better spacing */}
                <div className="space-y-4 sm:space-y-6 mb-8 sm:mb-10">
                  <div className="flex items-center gap-3 sm:gap-4 text-slate-200 hover:text-cyan-300 transition-colors duration-300 group/contact">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-cyan-400/20 to-blue-500/20 rounded-xl flex items-center justify-center backdrop-blur-sm border border-cyan-500/20 group-hover/contact:border-cyan-400/50 group-hover/contact:bg-cyan-400/10 transition-all duration-300 shadow-lg">
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-sm text-slate-400 font-medium">Phone</p>
                      <p className="text-base sm:text-lg font-semibold">+254 712 031 947</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-3 sm:gap-4 text-slate-200 hover:text-cyan-300 transition-colors duration-300 group/contact">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-cyan-400/20 to-blue-500/20 rounded-xl flex items-center justify-center backdrop-blur-sm border border-cyan-500/20 group-hover/contact:border-cyan-400/50 group-hover/contact:bg-cyan-400/10 transition-all duration-300 shadow-lg">
                      <svg className="w-5 h-5 sm:w-6 sm:h-6 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-slate-400 font-medium">Email</p>
                      <p className="text-base sm:text-lg font-semibold truncate">jtgenterprisesltd@gmail.com</p>
                    </div>
                  </div>
                </div>

                {/* Enhanced CTA Button */}
                <a href="#contact" className="inline-block">
                <button className="group/btn relative px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-cyan-500 via-blue-500 to-indigo-600 text-white font-bold rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-cyan-500/30 hover:-translate-y-1 hover:scale-105 active:scale-95 w-full sm:w-auto">
                  <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 via-blue-400 to-indigo-500 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300" />
                  <div className="absolute inset-0 bg-white/20 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300" />
                  <span className="relative flex items-center justify-center gap-3 text-base sm:text-lg">
                    Get In Touch
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 group-hover/btn:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </span>
                </button>
                </a>
              </div>

              {/* Navigation Section - Better organized */}
              <div className="lg:col-span-3 animate-slide-up-delayed">
                <div className="flex items-center gap-3 mb-6 sm:mb-8">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-purple-400/20 to-violet-500/20 rounded-xl flex items-center justify-center backdrop-blur-sm border border-purple-500/20 shadow-lg">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-white">Quick Links</h3>
                </div>

                <ul className="space-y-3 sm:space-y-4">
                  {[
                    { name: 'Home', href: '#home' },
                    { name: 'About Us', href: '#about' },
                    { name: 'Services', href: '#services' },
                    { name: 'Portfolio', href: '#portfolio' },
                    { name: 'Team', href: '#team' },
                    { name: 'Clients', href: '#clients' },
                    { name: 'Contact', href: '#contact' }
                  ].map((link, index) => (
                    <li key={index}>
                      <a 
                        href={link.href} 
                        className="group/link flex items-center gap-3 text-slate-300 hover:text-purple-300 transition-all duration-300 text-base sm:text-lg py-2 px-3 rounded-lg hover:bg-slate-800/30"
                      >
                        <div className="w-2 h-2 bg-slate-500 rounded-full group-hover/link:bg-purple-400 group-hover/link:scale-125 transition-all duration-300" />
                        <span className="group-hover/link:translate-x-2 transition-transform duration-300 font-medium">{link.name}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Address & Hours Section - More professional layout */}
              <div className="lg:col-span-4 animate-slide-up-more space-y-8 sm:space-y-10">
                {/* Address */}
                <div>
                  <div className="flex items-center gap-3 mb-4 sm:mb-6">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-emerald-400/20 to-teal-500/20 rounded-xl flex items-center justify-center backdrop-blur-sm border border-emerald-500/20 shadow-lg">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <h3 className="text-xl sm:text-2xl font-bold text-white">Address</h3>
                  </div>
                  <div className="bg-slate-800/30 rounded-xl p-4 sm:p-6 border border-slate-700/30">
                    <p className="text-slate-200 leading-relaxed text-base sm:text-lg">
                      P.O. Box 6787, Industrial Area Rd,<br />
                      <span className="text-emerald-300">Westlands</span>, Nairobi, Kenya
                    </p>
                  </div>
                </div>

                {/* Hours */}
                <div>
                  <div className="flex items-center gap-3 mb-4 sm:mb-6">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-emerald-400/20 to-teal-500/20 rounded-xl flex items-center justify-center backdrop-blur-sm border border-emerald-500/20 shadow-lg">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <h3 className="text-xl sm:text-2xl font-bold text-white">Business Hours</h3>
                  </div>
                  <div className="bg-slate-800/30 rounded-xl p-4 sm:p-6 border border-slate-700/30 space-y-3">
                    <div className="flex justify-between items-center">
                      <span className="text-slate-300 font-medium text-sm sm:text-base">Monday - Saturday</span>
                      <span className="text-emerald-300 font-bold text-sm sm:text-base">8:00 AM – 5:00 PM</span>
                    </div>
                    <div className="w-full h-px bg-slate-700/50"></div>
                    <div className="flex justify-between items-center">
                      <span className="text-slate-300 font-medium text-sm sm:text-base">Sunday</span>
                      <span className="text-slate-400 text-sm sm:text-base">Closed</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom - Enhanced */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-slate-700/20 to-transparent h-px"></div>
          <div className="pt-8 sm:pt-12 animate-fade-in-delayed">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-6 sm:gap-8">
              
              {/* Copyright */}
              <div className="text-slate-400 text-sm sm:text-base text-center lg:text-left">
                <p>&copy; {new Date().getFullYear()} <span className="text-slate-200 font-semibold">JTG Enterprises Limited</span>. All rights reserved.</p>
                <p className="text-xs sm:text-sm mt-1">Crafted with excellence in Nairobi, Kenya</p>
              </div>
              
              {/* Social Links */}
              <div className="flex items-center gap-3 sm:gap-4">
                {[
                  { icon: 'M18.77 7.46H15.5v-1.9c0-.9.6-1.1 1-1.1h2.1V2.5h-2.9c-3.1 0-3.8 2.3-3.8 3.8v1.1H9.5v1.9h2.4v9.4h3.8v-9.4h2.9l.17-1.9z', name: 'Facebook', color: 'hover:bg-blue-600/20 hover:border-blue-400/30 hover:text-blue-400' },
                  { icon: 'M23.32 4.56c-.8.35-1.69.59-2.6.69.94-.56 1.66-1.45 2-2.51-.87.52-1.84.9-2.87 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.52 2.02-4.52 4.52 0 .35.04.69.11 1.02-3.76-.19-7.09-1.99-9.33-4.73-.39.67-.61 1.45-.61 2.28 0 1.57.8 2.95 2.02 3.77-.74-.02-1.44-.23-2.05-.57v.06c0 2.19 1.56 4.02 3.63 4.44-.38.1-.78.16-1.19.16-.29 0-.57-.03-.85-.08.57 1.78 2.24 3.08 4.21 3.12-1.54 1.21-3.49 1.93-5.61 1.93-.36 0-.72-.02-1.07-.06 2 1.28 4.37 2.02 6.91 2.02 8.29 0 12.83-6.87 12.83-12.83 0-.2 0-.39-.01-.58.88-.63 1.64-1.42 2.24-2.32z', name: 'Twitter', color: 'hover:bg-sky-500/20 hover:border-sky-400/30 hover:text-sky-400' },
                  { icon: 'M20.45 20.45H16.9v-5.6c0-1.34-.03-3.06-1.86-3.06-1.87 0-2.16 1.46-2.16 2.96v5.7H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.86 3.37-1.86 3.61 0 4.27 2.37 4.27 5.46v6.29zM5.34 7.43c-1.13 0-2.05-.92-2.05-2.05s.92-2.05 2.05-2.05 2.05.92 2.05 2.05-.92 2.05-2.05 2.05zM7.11 20.45H3.57V9h3.54v11.45z', name: 'LinkedIn', color: 'hover:bg-blue-500/20 hover:border-blue-400/30 hover:text-blue-400' },
                  { icon: 'M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.097.118.112.221.085.343-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z', name: 'Pinterest', color: 'hover:bg-red-500/20 hover:border-red-400/30 hover:text-red-400' }
                ].map((social, index) => (
                  <button
                    key={index}
                    className={`group w-10 h-10 sm:w-12 sm:h-12 bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-xl flex items-center justify-center transition-all duration-300 ${social.color} hover:scale-110 hover:shadow-lg active:scale-95`}
                    title={social.name}
                  >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-slate-400 group-hover:scale-110 transition-all duration-300" fill="currentColor" viewBox="0 0 24 24">
                      <path d={social.icon} />
                    </svg>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(2deg); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(-2deg); }
        }
        @keyframes float-slow {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(1deg); }
        }
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 15s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 18s ease-in-out infinite 2s;
        }
        .animate-float-slow {
          animation: float-slow 20s ease-in-out infinite 4s;
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
        .animate-fade-in-delayed {
          animation: fade-in 1s ease-out 0.4s both;
        }
        .animate-slide-up {
          animation: slide-up 1s ease-out 0.6s both;
        }
        .animate-slide-up-delayed {
          animation: slide-up 1s ease-out 0.8s both;
        }
        .animate-slide-up-more {
          animation: slide-up 1s ease-out 1s both;
        }
      `}</style>
    </footer>
  );
};

export default Footer;